const PREFIX1 = '/v1/Resource/File'
const PREFIX2 = '/v1/gateway/fileUploadService'

export const URL = {
  ADD: PREFIX1 + '/add',
  DEL: PREFIX1 + '/delete',
  EDIT: PREFIX1 + '/edit',
  LIST: PREFIX1 + '/list',
  DETAIL: PREFIX1 + '/view',
  ORDER: PREFIX1 + '/order',
  DISABLE: PREFIX1 + '/disable',
  ENABLE: PREFIX1 + '/able',
  UPLOAD: PREFIX2 + '/upload'
}
